module.exports = __webpack_public_path__ + "img/icon6.13eca73d.png";